import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import Modal from 'components/Modal';

import MessageNewForm from 'components/forms/messaging/MessageNewForm';
import { isPluginActive } from 'helpers/whiteLabel';
import { EMAIL_INTEGRATION_MS_PLUGIN } from 'js/constants';

class MessageNew extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shown: false,
      isOutlookActive: false,
    };
  }

  componentDidMount() {
    const { projectConfig } = this.props;
    this.setState({ isOutlookActive: isPluginActive(EMAIL_INTEGRATION_MS_PLUGIN, projectConfig.data) });
  }

  onShow = () => {
    this.setState({ shown: true });
  };

  onExit = () => {
    this.setState({ shown: false });
  };

  render() {
    const {
      intl: { messages },
      show,
      close,
      onSubmitParent,
      client,
      user,
    } = this.props;
    const { isOutlookActive, shown } = this.state;

    return (
      <Modal show={show} onHide={close} bsSize="lg" onExit={this.onExit} onShow={this.onShow}>
        <Modal.Header closeButton>
          <Modal.Title>{messages.create_message}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MessageNewForm
            shown={shown}
            client={client}
            onSubmitParent={onSubmitParent}
            sendHint={{
              type: isOutlookActive ? 'outlook' : '',
              message: isOutlookActive ? (
                <FormattedMessage id="send_mail_via_outlook" values={{ email: user.profile.email }} />
              ) : (
                undefined
              ),
            }}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    projectConfig: state.data.projectConfig,
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(MessageNew));
